import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Node from './Node';

const BoxTimeline = ({
  nodes, currentStep, isMobile, trackingUrl,
}) => {
  const [visibleNodes, setVisibleNodes] = useState(nodes);
  useEffect(() => {
    if (!trackingUrl.includes('fedex.com')) {
      setVisibleNodes(nodes.filter((n) => n.label !== 'Delivered'));
    }
  }, [trackingUrl]);
  return (
    <div
      className={`box-timeline ${
        visibleNodes.length === 4 ? 'shorter-timeline' : ''
      }`}
    >
      {visibleNodes
        && visibleNodes.map((node, index) => {
          const activeStepIndex = visibleNodes.findIndex(
            (x) => x.label === currentStep,
          );
          let nodeStatus = index < activeStepIndex ? 'past' : '';
          nodeStatus = index === activeStepIndex ? 'active' : nodeStatus;
          const data = { message: node.label, status: nodeStatus };
          return (
            <div
              key={node.label}
              className={
                isMobile
                  ? 'challenge-timeline__node-box'
                  : 'challenge-timeline__node-box-desktop'
              }
            >
              <Node
                data={data}
                isBoxNode
                isMobile={isMobile}
                trackingUrl={trackingUrl}
              />
              {index < visibleNodes.length - 1 && (
                <div
                  className={cx(
                    isMobile
                      ? 'challenge-timeline__node-box__line'
                      : 'challenge-timeline__node-box__line-desktop',
                    { solid: index < activeStepIndex && 'solid' },
                  )}
                />
              )}
            </div>
          );
        })}
    </div>
  );
};

BoxTimeline.defaultProps = {
  nodes: [],
  currentStep: '',
  isMobile: true,
  trackingUrl: '',
};

BoxTimeline.propTypes = {
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      message: PropTypes.string,
      order: PropTypes.number,
    }),
  ),
  currentStep: PropTypes.string,
  trackingUrl: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default BoxTimeline;
